import {
  removeAllFilters,
  extractTextFromButton,
  changeBtnHtml,
  showAllUnfilteredCategoryItems,
  renderSeeMoreButton,
  hideExcessEntries,
  attachSeeMoreButtonHandlers,
} from "./sidenavHelpers";

const getSideNavContainerElement = () => document.querySelector(".sidenav");
const getMobileHeaderElement = () => document.querySelector(".sidenav__dropdown");
const seeMoreSliceOptions = { mobile: 8, desktop: 21 };

const validParams = (paramStr) => {
  const validParams = ['Commercial', 'Industrial', 'Heavy civil', 'Healthcare', 'Education', 'Residential'];
  return paramStr !== "" || validParams.includes(paramStr);
};

const filterFromParams = (param, initialFilter, elementsClass) => {
  const filterElement = document.querySelector(`li[data-link-category="${param}"]`);
  addCurrentClassToCategoryLink(filterElement);
  filterElements(param, elementsClass, initialFilter);
};

const checkParams = (paramOption, initialFilter, elementsClass) => {
  const param = window.location.search.substr(1).replace('%20', ' ');
  if (!paramOption || !validParams(param)) { return; }

  filterFromParams(param, initialFilter, elementsClass);
};

const addInitialCurrentClass = (category) => {
  const initialFilter = document.querySelector(`li[data-link-category="${category}"]`);

  initialFilter.classList.add('current');
};

const addMobileDropdownEvent = () => {
  const mobileMenuHeader = getMobileHeaderElement();

  mobileMenuHeader.addEventListener("click", () => {
    toggleMobileMenu();
  });
};

const toggleMobileMenu = () => {
  const mobileMenuHeader = getMobileHeaderElement();
  const sideNavContainer = getSideNavContainerElement();

  mobileMenuHeader.classList.toggle("open");

  sideNavContainer.classList.toggle("closed");
};

const filterElements = (category, elementsClass, allFilter) => {
  removeAllFilters(elementsClass);

  if (category === allFilter) { return; }

  [...document.querySelectorAll(`.${elementsClass}`)].forEach((el) => {
    if (el.getAttribute("data-filter-category") !== category) {
      el.classList.add("filtered");
    }
  });
};

const addCurrentClassToCategoryLink = (element) => {
  [...document.querySelectorAll("li[data-link-category]")].forEach((link) => {
    link.classList.remove("current");
  });

  element.classList.add("current");
};

const scrollAndCheckHeight = () => {
  const sidenav = document.querySelector('.sidenav__container');
  const partnersWrapper = document.querySelector('.partnersMainBlock');
  const projectsWrapper = document.querySelector('.projects__container');
  window.scrollTo(0, 440);
  if (partnersWrapper) {
    sidenav.style.maxHeight = `${Math.min(300, partnersWrapper.offsetHeight)}px`;
  } else {
    sidenav.style.maxHeight = `${Math.min(300, projectsWrapper.offsetHeight)}px`;
  }
};

const addFilterEvents = (categoryElementsClass, seeMoreButton, initialFilter) => {
  [...document.querySelectorAll(".sidenav > ul:first-of-type li")].forEach((link) => {
    link.addEventListener("click", (e) => {
      e.preventDefault();
      const target = e.currentTarget;
      const category = target.getAttribute("data-link-category");
      const isCurrent = target.classList.contains("current");

      if (!isCurrent) {
        addCurrentClassToCategoryLink(target);
        filterElements(category, categoryElementsClass, initialFilter);

        if (seeMoreButton) {
          renderSeeMoreButton(seeMoreButton, categoryElementsClass, seeMoreSliceOptions);
        }
      }

      if (window.matchMedia("(min-width: 62em)").matches) {
        scrollAndCheckHeight();
      }

      toggleMobileMenu();
    });
  });
}

const addFixedScrollEvent = () => {
  const container = document.querySelector(".sidenav__container");
  const footer = document.querySelector("#footer-navigation");
  const footerHeight = footer.offsetHeight;

  const margin = 100;

  window.addEventListener("scroll", () => {
    const containerHeight = container.offsetHeight;
    const footerTop = document.body.offsetHeight - footerHeight;
    if (window.matchMedia("(min-width: 62em)").matches) {
      if (containerHeight + pageYOffset + margin > footerTop) {
        container.style.position = "fixed";
        container.style.maxHeight = `${(pageYOffset + margin - footerTop) * -1}px`;
      } else if (pageYOffset > 465) {
        container.style.position = "fixed";
        container.style.top = "100px";
        container.style.maxHeight = "300px";
      } else {
        container.style.position = "absolute";
        container.style.top = "0";
      }
    }
  })
};

const attachSidenavEvents = ({ filterElementsClass, initialFilter, seeMoreButtonClass, paramOption }) => {
  addInitialCurrentClass(initialFilter);
  checkParams(paramOption, initialFilter, filterElementsClass);
  attachSeeMoreButtonHandlers(seeMoreButtonClass, filterElementsClass, seeMoreSliceOptions);
  addMobileDropdownEvent();
  addFilterEvents(filterElementsClass, seeMoreButtonClass, initialFilter);
  addFixedScrollEvent();
};

export default attachSidenavEvents;



// WEBPACK FOOTER //
// ./src/pages/helpers/attachSidenavEvents.js